module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.template && _vm.response) ? _c('document-container', {
    attrs: {
      "footer": [],
      "header": _vm.header,
      "logo": _vm.logo,
      "documentType": "approval",
      "orientation": "landscape"
    }
  }, [_vm._l((_vm.response.steps), function(step, stepKey) {
    return [(step.title) ? _c('div', {
      staticClass: "page-block fake-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('h2', [_vm._v(_vm._s(step.title) + "\n        "), (step.footnotes) ? _c('footnotes', {
      attrs: {
        "all-footnotes": _vm.footnotes,
        "local-footnotes": step.footnotes
      }
    }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm._l((step.fields), function(field, fieldKey) {
      return (!field.conditionalOn || (step.fields.find(function (el) { return el.key === field.conditionalOn; }).props.defaultValue)) ? _c('APPROVAL_' + field.fieldType, {
        key: stepKey + '-' + fieldKey,
        tag: "component",
        staticClass: "page-block fake-block",
        attrs: {
          "slot": "raw-body",
          "data": field,
          "footnotes": _vm.footnotes
        },
        slot: "raw-body"
      }) : _vm._e()
    })]
  }), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('div', [_c('strong', [_vm._v("Erfasser:")]), _vm._v(" " + _vm._s(_vm.email) + "   |   "), _c('strong', [_vm._v("Datum:")]), _vm._v(" " + _vm._s(_vm.moment().format('DD. MMMM YYYY')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('hr'), _vm._v(" "), _vm._l((_vm.footnotes), function(footnote, index) {
    return _c('div', [_c('span', {
      staticStyle: {
        "vertical-align": "super",
        "font-size": "8px",
        "font-weight": "lighter"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n      " + _vm._s(footnote) + "\n    ")])
  })], 2)], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f112777"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/approval/Approval.vue
// module id = 690
// module chunks = 0